import { MdxPage } from '@features/mdx/MdxPage';
import { AppLanguageCodes } from '@project-types/AppLanguageCodes';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';



const articleIds: MdxPageArticleIds = {
	[AppLanguageCodes.CZ]: '88e5668c-4f26-4ac0-836f-38ceeee14138',
	[AppLanguageCodes.SK]: '88e5668c-4f26-4ac0-836f-38ceeee14138',
	[AppLanguageCodes.DE]: '88e5668c-4f26-4ac0-836f-38ceeee14138',
}


export const Faq = () => {

	return (
		<MdxPage className='faq-page' articleIds={articleIds} />
	);
};